import React, { createContext, useContext } from 'react';

const AdminContext = createContext<any>(null);

export const useAdminContext = () => {
  const value = useContext(AdminContext);
  if (!value) throw new Error('AdminContext missing');
  return value;
};

export const AdminProvider = ({ value, children }: { value: any; children: React.ReactNode }) => (
  <AdminContext.Provider value={value}>{children}</AdminContext.Provider>
);
